import { render } from "./change-language-box.vue?vue&type=template&id=1c8d9a56"
import script from "./change-language-box.vue?vue&type=script&lang=js"
export * from "./change-language-box.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__